export const categories = {
  "رياضيات 1: الأنماط والأعداد حتى ٩": [
    {
      title: "الفصل ١ - الدرس ١: أنماط من عنصرين",
      file: "1",
      country: "syria"
    },
    {
      title: "الفصل ١ - الدرس ٢: أنماط من ثلاثة عناصر",
      file: "2",
      country: "syria"
    },
    {
      title: "الفصل ٢ - الدرس ١: العددان ١ و ٢",
      file: "3",
      country: "syria"
    },
    {
      title: "الفصل ٢ - الدرس ٢: العددان ٣ و ٤",
      file: "4",
      country: "syria"
    },
    {
      title: "الفصل ٢ - الدرس ٣: العددان ٥ و ٦",
      file: "5",
      country: "syria"
    },
    {
      title: "الفصل ٢ - الدرس ٤: الأعداد ٧، ٨، ٩",
      file: "6",
      country: "syria"
    },
    {
      title: "الفصل ٢ - الدرس ٥: العدد صفر",
      file: "7",
      country: "syria"
    },
    {
      title: "الفصل ٢ - الدرس ٦: الأكبر والأصغر",
      file: "8",
      country: "syria"
    },
    {
      title: "الفصل ٢ - الدرس ٧: المساواة",
      file: "9",
      country: "syria"
    },
    {
      title: "الفصل ٣ - الدرس ١: مكونات العددين ٤ و ٥",
      file: "10",
      country: "syria"
    },
    {
      title: "الفصل ٣ - الدرس ٢: مكونات العدد ٦",
      file: "11",
      country: "syria"
    },
    {
      title: "الفصل ٣ - الدرس ٣: مكونات العدد ٧",
      file: "12",
      country: "syria"
    },
    {
      title: "الفصل ٣ - الدرس ٤: مكونات العددين ٨ و ٩",
      file: "13",
      country: "syria"
    },
    {
      title: "الفصل ٣ - الدرس ٥: استكشاف الأجزاء الناقصة",
      file: "14",
      country: "syria"
    }
  ],
  "رياضيات 2: الأعداد حتى ١٢ والعمليات الأولية": [
    {
      title: "الفصل ٤ - الدرس ١: العدد ١٠",
      file: "15",
      country: "syria"
    },
    {
      title: "الفصل ٤ - الدرس ٢: مكونات العدد ١٠",
      file: "16",
      country: "syria"
    },
    {
      title: "الفصل ٤ - الدرس ٣: العد التصاعدي والتنازلي",
      file: "17",
      country: "syria"
    },
    {
      title: "الفصل ٤ - الدرس ٤: العددان ١١ و ١٢",
      file: "18",
      country: "syria"
    },
    {
      title: "الفصل ٤ - الدرس ٥: مكونات العددين ١١ و ١٢",
      file: "19",
      country: "syria"
    },
    {
      title: "الفصل ٤ - الدرس ٦: الأكبر والأصغر",
      file: "20",
      country: "syria"
    },
    {
      title: "الفصل ٥ - الدرس ١: استكشاف الجمع",
      file: "21",
      country: "syria"
    },
    {
      title: "الفصل ٥ - الدرس ٢: الجمع الأفقي والعمودي",
      file: "22",
      country: "syria"
    },
    {
      title: "الفصل ٥ - الدرس ٣: استكشاف الطرح",
      file: "23",
      country: "syria"
    },
    {
      title: "الفصل ٥ - الدرس ٤: الطرح الأفقي والعمودي",
      file: "24",
      country: "syria"
    },
    {
      title: "الفصل ٥ - الدرس ٥: حل المسائل باستعمال الجمع",
      file: "25",
      country: "syria"
    },
    {
      title: "الفصل ٦ - الدرس ١: الجمع عملية تبديلية",
      file: "26",
      country: "syria"
    },
    {
      title: "الفصل ٦ - الدرس ٢: جمع العدد إلى نفسه",
      file: "27",
      country: "syria"
    },
    {
      title: "الفصل ٦ - الدرس ٣: الجمع على مستقيم الأعداد",
      file: "28",
      country: "syria"
    },
    {
      title: "الفصل ٦ - الدرس ٤: الطرح على مستقيم الأعداد",
      file: "29",
      country: "syria"
    },
    {
      title: "الفصل ٦ - الدرس ٥: حل المسائل",
      file: "30",
      country: "syria"
    },
    {
      title: "الفصل ٦ - الدرس ٦: الأعداد الترتيبية",
      file: "31",
      country: "syria"
    },
    {
      title: "الفصل ٧ - الدرس ١: المجسمات",
      file: "32",
      country: "syria"
    },
    {
      title: "الفصل ٧ - الدرس ٢: الأشكال الهندسية",
      file: "33",
      country: "syria"
    },
    {
      title: "الفصل ٧ - الدرس ٣: التطابق",
      file: "34",
      country: "syria"
    },
    {
      title: "الفصل ٨ - الدرس ١: استكشاف الأجزاء المتساوية",
      file: "35",
      country: "syria"
    },
    {
      title: "الفصل ٨ - الدرس ٢: النصف",
      file: "36",
      country: "syria"
    },
    {
      title: "الفصل ٨ - الدرس ٣: الربع",
      file: "37",
      country: "syria"
    }
  ],
  "رياضيات 3: الأعداد حتى ٩٩ والمفاهيم المتقدمة": [
    {
      title: "الفصل ٩ - الدرس ١: الأعداد من ١٠ إلى ١٩",
      file: "38",
      country: "syria"
    },
    {
      title: "الفصل ٩ - الدرس ٢: مكونات الأعداد",
      file: "39",
      country: "syria"
    },
    {
      title: "الفصل ٩ - الدرس ٣: مقارنة الأعداد حتى ١٩",
      file: "40",
      country: "syria"
    },
    {
      title: "الفصل ٩ - الدرس ٤: الجمع بالإتمام إلى عشرة",
      file: "41",
      country: "syria"
    },
    {
      title: "الفصل ٩ - الدرس ٥: العلاقة بين الجمع والطرح",
      file: "42",
      country: "syria"
    },
    {
      title: "الفصل ٩ - الدرس ٦: حل مسائل",
      file: "43",
      country: "syria"
    },
    {
      title: "الفصل ١٠ - الدرس ١: العد بالعشرات",
      file: "44",
      country: "syria"
    },
    {
      title: "الفصل ١٠ - الدرس ٢: الأعداد حتى ٩٩",
      file: "45",
      country: "syria"
    },
    {
      title: "الفصل ١٠ - الدرس ٣: آحاد وعشرات حتى ٩٩",
      file: "46",
      country: "syria"
    },
    {
      title: "الفصل ١٠ - الدرس ٤: مقارنة الأعداد حتى ٩٩",
      file: "47",
      country: "syria"
    },
    {
      title: "الفصل ١٠ - الدرس ٥: ترتيب الاعداد حتى ٩٩",
      file: "48",
      country: "syria"
    },
    {
      title: "الفصل ١٠ - الدرس ٦: العد التجاوزي بالاثنينات",
      file: "49",
      country: "syria"
    },
    {
      title: "الفصل ١٠ - الدرس ٧: العد التجاوزي بالخمسات",
      file: "50",
      country: "syria"
    },
    {
      title: "الفصل ١١ - الدرس ١: النقود",
      file: "51",
      country: "syria"
    },
    {
      title: "الفصل ١١ - الدرس ٢: القطع النقدية ومكوناتها",
      file: "52",
      country: "syria"
    },
    {
      title: "الفصل ١١ - الدرس ٣: الأوراق النقدية ومكوناتها",
      file: "53",
      country: "syria"
    },
    {
      title: "الفصل ١١ - الدرس ٤: حل المسائل (النقود)",
      file: "54",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ١: جمع ثلاثة أعداد بالترتيب",
      file: "55",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ٢: جمع ثلاثة أعداد بتكوين عشرة",
      file: "56",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ٣: جمع العشرات وطرحها",
      file: "57",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ٤: جمع وطرح عدد من منزلتين مع عشرات",
      file: "58",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ٥: جمع عدد من منزلتين مع آحاد",
      file: "59",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ٦: جمع عددين من منزلتين",
      file: "60",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ٧: طرح آحاد من عدد من منزلتين",
      file: "61",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ٨: طرح عددين من منزلتين",
      file: "62",
      country: "syria"
    },
    {
      title: "الفصل ١٢ - الدرس ٩: حل مسائل (اختيار العملية)",
      file: "63",
      country: "syria"
    },
    {
      title: "الفصل ١٣ - الدرس ١: الساعة",
      file: "64",
      country: "syria"
    },
    {
      title: "الفصل ١٣ - الدرس ٢: قياس الطول بوحدات غير نظامية",
      file: "65",
      country: "syria"
    }
  ],
  "اللغة العربية": [
    {
      title: "الوحدة ١ - الدرس ١: الشَّجَرَةُ",
      file: "66",
      country: "syria"
    },
    {
      title: "الوحدة ١ - الدرس ٢: العصفورة",
      file: "67",
      country: "syria"
    },
    {
      title: "الوحدة ١ - الدرس ٣: صديقتي المياه",
      file: "68",
      country: "syria"
    },
    {
      title: "الوحدة ١ - الدرس ٤: الشتاء",
      file: "69",
      country: "syria"
    },
    {
      title: "الوحدة ٢ - الدرس ١: أُنظف مدرستي",
      file: "70",
      country: "syria"
    },
    {
      title: "الوحدة ٢ - الدرس ٢: صحة الأسنان",
      file: "71",
      country: "syria"
    },
    {
      title: "الوحدة ٢ - الدرس ٣: غذائي",
      file: "72",
      country: "syria"
    },
    {
      title: "الوحدة ٢ - الدرس ٤: الحواس الخمس",
      file: "73",
      country: "syria"
    },
    {
      title: "الوحدة ٣ - الدرس ١: في قلبي",
      file: "74",
      country: "syria"
    },
    {
      title: "الوحدة ٣ - الدرس ٢: التَّعاون",
      file: "75",
      country: "syria"
    },
    {
      title: "الوحدة ٣ - الدرس ٣: الصغيرَةُ الجَميلَةُ",
      file: "76",
      country: "syria"
    },
    {
      title: "الوحدة ٣ - الدرس ٤: أحب أن أكون",
      file: "77",
      country: "syria"
    }
  ],
  "العلوم": [
    {
      title: "الوحدة الأولى - الدرس ١: حي وغير حي",
      file: "101",
      country: "syria"
    },
    {
      title: "الوحدة الأولى - الدرس ٢: تعيش معنا",
      file: "102",
      country: "syria"
    },
    {
      title: "الوحدة الأولى - الدرس ٣: كانت حية",
      file: "103",
      country: "syria"
    },
    {
      title: "الوحدة الأولى - الدرس ٤: أكتشف عالمي",
      file: "104",
      country: "syria"
    },
    {
      title: "الوحدة الأولى - الدرس ٥: ثلج وماء وهواء",
      file: "105",
      country: "syria"
    },
    {
      title: "الوحدة الأولى - الدرس ٦: عالمي يتغير",
      file: "106",
      country: "syria"
    },
    {
      title: "الوحدة الأولى - الدرس ٧: حيث نعيش",
      file: "107",
      country: "syria"
    },
    {
      title: "الوحدة الأولى - الدرس ٨: نكتشف معاً",
      file: "108",
      country: "syria"
    },
    {
      title: "الوحدة الثانية - الدرس ١: صغار الحيوانات",
      file: "109",
      country: "syria"
    },
    {
      title: "الوحدة الثانية - الدرس ٢: عطاء الله",
      file: "110",
      country: "syria"
    },
    {
      title: "الوحدة الثانية - الدرس ٣: ألعب وأتحرك",
      file: "111",
      country: "syria"
    },
    {
      title: "الوحدة الثانية - الدرس ٤: أدفع .... أسحب",
      file: "112",
      country: "syria"
    },
    {
      title: "الوحدة الثالثة - الدرس ١: أنمو وأكبر",
      file: "113",
      country: "syria"
    },
    {
      title: "الوحدة الثالثة - الدرس ٢: حياتي .... صحتي",
      file: "114",
      country: "syria"
    },
    {
      title: "الوحدة الثالثة - الدرس ٣: تنير حياتي",
      file: "115",
      country: "syria"
    },
    {
      title: "الوحدة الثالثة - الدرس ٤: القوة الخفية",
      file: "116",
      country: "syria"
    },
    {
      title: "الوحدة الثالثة - الدرس ٥: تجاذب ... تنافر",
      file: "117",
      country: "syria"
    },
    {
      title: "الوحدة الرابعة - الدرس ١: حواسي",
      file: "118",
      country: "syria"
    },
    {
      title: "الوحدة الرابعة - الدرس ٢: كيف تساعدني حواسي",
      file: "119",
      country: "syria"
    },
    {
      title: "الوحدة الرابعة - الدرس ٣: الأصدقاء الخمسة",
      file: "120",
      country: "syria"
    },
    {
      title: "الوحدة الرابعة - الدرس ٤: سلامة حواسي",
      file: "121",
      country: "syria"
    },
    {
      title: "الوحدة الرابعة - الدرس ٥: رحلة الضوء",
      file: "122",
      country: "syria"
    },
    {
      title: "الوحدة الرابعة - الدرس ٦: الأجسام الشفافة",
      file: "123",
      country: "syria"
    },
    {
      title: "الوحدة الرابعة - الدرس ٧: الظل رفيق الضوء",
      file: "124",
      country: "syria"
    },
    {
      title: "الوحدة الرابعة - الدرس ٨: رحلة الصوت",
      file: "125",
      country: "syria"
    },
    {
      title: "الوحدة الخامسة - الدرس ٩: غذائي",
      file: "126",
      country: "syria"
    },
    {
      title: "الوحدة الخامسة - الدرس ١٠: عالمي الجميل أحبه أن يكون",
      file: "127",
      country: "syria"
    },
    {
      title: "الوحدة الخامسة - الدرس ١١: تنمو وتتحرك",
      file: "128",
      country: "syria"
    },
    {
      title: "الوحدة الخامسة - الدرس ١٢: أقسام النبات",
      file: "129",
      country: "syria"
    },
    {
      title: "الوحدة الخامسة - الدرس ١٣: من البذور إلى النبات",
      file: "130",
      country: "syria"
    },
    {
      title: "الوحدة الخامسة - الدرس ١٤: حاجات النبات",
      file: "131",
      country: "syria"
    }
  ],
  "اللغة الإنجليزية": [
    {
      title: "Unit 1: Hello!",
      file: "132",
      country: "syria"
    },
    {
      title: "Unit 2: Counting",
      file: "133",
      country: "syria"
    },
    {
      title: "Unit 3: Classroom objects",
      file: "134",
      country: "syria"
    },
    {
      title: "Unit 4: Close the window, please.",
      file: "135",
      country: "syria"
    },
    {
      title: "Unit 5: Revision 1",
      file: "136",
      country: "syria"
    },
    {
      title: "Unit 6: Let's eat!",
      file: "137",
      country: "syria"
    },
    {
      title: "Unit 7: What colour is the ...?",
      file: "138",
      country: "syria"
    },
    {
      title: "Unit 8: My face",
      file: "139",
      country: "syria"
    },
    {
      title: "Unit 9: My family",
      file: "140",
      country: "syria"
    },
    {
      title: "Unit 10: Revision 2",
      file: "141",
      country: "syria"
    },
    {
      title: "Unit 11: My birthday",
      file: "142",
      country: "syria"
    },
    {
      title: "Unit 12: Is the bed green?",
      file: "143",
      country: "syria"
    },
    {
      title: "Unit 13: My body",
      file: "144",
      country: "syria"
    },
    {
      title: "Unit 14: What's that?",
      file: "145",
      country: "syria"
    },
    {
      title: "Unit 15: Revision 3",
      file: "146",
      country: "syria"
    },
    {
      title: "Unit 16: Our clothes",
      file: "147",
      country: "syria"
    },
    {
      title: "Unit 17: Where is it?",
      file: "148",
      country: "syria"
    },
    {
      title: "Unit 18: I like ice cream.",
      file: "149",
      country: "syria"
    },
    {
      title: "Unit 19: Animals",
      file: "150",
      country: "syria"
    },
    {
      title: "Unit 20: Revision 4",
      file: "151",
      country: "syria"
    },
    {
      title: "Unit 21: Is that Zeina's vase?",
      file: "152",
      country: "syria"
    },
    {
      title: "Unit 22: Where's Mother?",
      file: "153",
      country: "syria"
    },
    {
      title: "Unit 23: I'm tall.",
      file: "154",
      country: "syria"
    },
    {
      title: "Unit 24: The alphabet",
      file: "155",
      country: "syria"
    },
    {
      title: "Unit 25: Revision 5",
      file: "156",
      country: "syria"
    }
  ],
  "الاجتماعيات": [
    {
      title: "الوحدة ١ - الدرس ١: مَنْ أنا؟",
      file: "78",
      country: "syria"
    },
    {
      title: "الوحدة ١ - الدرس ٢: نتشابه ونختلف",
      file: "79",
      country: "syria"
    },
    {
      title: "الوحدة ١ - الدرس ٣: مشاعري",
      file: "80",
      country: "syria"
    },
    {
      title: "الوحدة ١ - الدرس ٤: كيف أمضي يومي؟",
      file: "81",
      country: "syria"
    },
    {
      title: "الوحدة ١ - الدرس ٥: أنا قادر",
      file: "82",
      country: "syria"
    },
    {
      title: "الوحدة ١ - الدرس ٦: سأحقق هدفي",
      file: "83",
      country: "syria"
    },
    {
      title: "الوحدة ٢ - الدرس ١: صغار كبار",
      file: "84",
      country: "syria"
    },
    {
      title: "الوحدة ٢ - الدرس ٢: أنا وأسرتي",
      file: "85",
      country: "syria"
    },
    {
      title: "الوحدة ٢ - الدرس ٣: أحب المساعدة",
      file: "86",
      country: "syria"
    },
    {
      title: "الوحدة ٢ - الدرس ٤: آداب الحوار",
      file: "87",
      country: "syria"
    },
    {
      title: "الوحدة ٣ - الدرس ١: أعبر الشارع بأمان",
      file: "88",
      country: "syria"
    },
    {
      title: "الوحدة ٣ - الدرس ٢: ألعب بأمان",
      file: "89",
      country: "syria"
    },
    {
      title: "الوحدة ٣ - الدرس ٣: أبقى حذراً",
      file: "90",
      country: "syria"
    },
    {
      title: "الوحدة ٣ - الدرس ٤: اللقاح حقي",
      file: "91",
      country: "syria"
    },
    {
      title: "الوحدة ٤ - الدرس ١: في مدرستي",
      file: "92",
      country: "syria"
    },
    {
      title: "الوحدة ٤ - الدرس ٢: حقوقي وواجباتي",
      file: "93",
      country: "syria"
    },
    {
      title: "الوحدة ٤ - الدرس ٣: لي دور",
      file: "94",
      country: "syria"
    },
    {
      title: "الوحدة ٥ - الدرس ١: الطبيعة والمزرعة",
      file: "95",
      country: "syria"
    },
    {
      title: "الوحدة ٥ - الدرس ٢: الأصدقاء الأربعة",
      file: "96",
      country: "syria"
    },
    {
      title: "الوحدة ٥ - الدرس ٣: طبيعتنا الجميلة",
      file: "97",
      country: "syria"
    },
    {
      title: "الوحدة ٥ - الدرس ٤: أغلى من الذهب",
      file: "98",
      country: "syria"
    },
    {
      title: "الوحدة ٥ - الدرس ٥: كنزنا الثمين",
      file: "99",
      country: "syria"
    },
    {
      title: "الوحدة ٥ - الدرس ٦: رحلة في الفضاء",
      file: "100",
      country: "syria"
    }
  ]
};